import { storeCreator } from '@/utils/store/store.utils';

interface State {
  highlightedTaxFormId?: string;
  setHighlightedTaxFormId: (value: string) => void;
  reset: () => void;
}

const useHighlightedTaxFormStore = storeCreator<State>((set) => ({
  highlightedTaxFormId: undefined,

  setHighlightedTaxFormId: (value: string) => set((state) => ({
    ...state,
    highlightedTaxFormId: value,
  })),

  reset: () => set((state) => ({
    ...state,
    highlightedTaxFormId: undefined,
  })),
}));

export default useHighlightedTaxFormStore;
